import React from 'react';
import { Category } from '@fa-metier/types';
import { CATEGORY_CONFIG } from './Config';
import GouvernanceIcon from '../icons/GouvernanceIcon';
import EnvironnementIcon from '../icons/EnvironnementIcon';
import SocialIcon from '../icons/SocialIcon';
import TerritoireIcon from '../icons/TerritoireIcon';
import EmploiIcon from '../icons/EmploiIcon';
export function getIcon(category, iconClassName, iconSize) {
    const size = iconSize; // background ? 350 : 32
    const color = CATEGORY_CONFIG[category].color;
    const { icon } = CATEGORY_CONFIG[category];
    const [width, height, , , path] = icon.icon;
    switch (category) {
        case Category.Governance:
            return React.createElement(GouvernanceIcon, { className: iconClassName, fill: color, width: size, height: size });
        case Category.Environment:
            return React.createElement(EnvironnementIcon, { className: iconClassName, fill: color, width: size, height: size });
        case Category.Social:
            return React.createElement(SocialIcon, { className: iconClassName, fill: color, width: size, height: size });
        case Category.Territory:
            return (React.createElement(TerritoireIcon, { className: iconClassName, fill: color, width: size, height: size }));
        case Category.Employment:
            return React.createElement(EmploiIcon, { className: iconClassName, fill: color, width: size, height: size });
        default:
            return (React.createElement("div", { className: iconClassName },
                React.createElement("svg", { width: size, height: size, viewBox: `0 0 ${width} ${height}`, fill: color },
                    React.createElement("path", { d: Array.isArray(path) ? path[0] : path }))));
    }
}
//# sourceMappingURL=IconManager.js.map